import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { devToolsRoutes } from './features/dev-tools/dev-tools.routes';

export const appRoutes: Routes = [
  {
    path: 'activate',
    loadComponent: () => import('./features/auth/accept-invitation/accept-invitation').then((m) => m.AcceptInvitation),
  },
  {
    path: 'auth/login',
    loadComponent: () => import('./features/auth/login/login').then((m) => m.Login),
  },
  {
    path: 'auth/accept-invitation',
    loadComponent: () => import('./features/auth/accept-invitation/accept-invitation').then((m) => m.AcceptInvitation),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/layout').then((m) => m.Layout),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'users',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/users/users').then((m) => m.Users),
      },
      {
        path: 'admin/account-holders/compare',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/account-holder-compare/account-holder-compare-page').then((m) => m.AccountHolderComparePage),
      },
      {
        path: 'partners',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-partners/admin-partners-list-page').then((m) => m.AdminPartnersListPage),
      },
      {
        path: 'partners/create',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN'],
        },
        loadComponent: () => import('./features/admin-partners/admin-partner-create-page').then((m) => m.AdminPartnerCreatePage),
      },
      {
        path: 'partners/:id',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN'],
        },
        loadComponent: () => import('./features/admin-partners/admin-partner-details-page').then((m) => m.AdminPartnerDetailsPage),
      },
      {
        path: 'admin-partners',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-partners/admin-partners-list-page').then((m) => m.AdminPartnersListPage),
      },
      {
        path: 'admin-partners/create',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN'],
        },
        loadComponent: () => import('./features/admin-partners/admin-partner-create-page').then((m) => m.AdminPartnerCreatePage),
      },
      {
        path: 'admin-partners/:id',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN'],
        },
        loadComponent: () => import('./features/admin-partners/admin-partner-details-page').then((m) => m.AdminPartnerDetailsPage),
      },
      {
        path: 'offers',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offers-list-page').then((m) => m.AdminFinancingOffersListPage),
      },
      {
        path: 'offers/create',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offer-create-page').then((m) => m.AdminFinancingOfferCreatePage),
      },
      {
        path: 'offers/:id/edit',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offer-edit-page').then((m) => m.AdminFinancingOfferEditPage),
      },
      {
        path: 'offers/:id',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offer-details-page').then((m) => m.AdminFinancingOfferDetailsPage),
      },
      {
        path: 'admin-financing-offers',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offers-list-page').then((m) => m.AdminFinancingOffersListPage),
      },
      {
        path: 'admin-financing-offers/create',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offer-create-page').then((m) => m.AdminFinancingOfferCreatePage),
      },
      {
        path: 'admin-financing-offers/:id/edit',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offer-edit-page').then((m) => m.AdminFinancingOfferEditPage),
      },
      {
        path: 'admin-financing-offers/:id',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-financing-offers/admin-financing-offer-details-page').then((m) => m.AdminFinancingOfferDetailsPage),
      },
      {
        path: 'loan-applications',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-financing-applications/admin-financing-applications-page').then((m) => m.AdminFinancingApplicationsPage),
      },
      {
        path: 'imf-account-opening/configuration',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/imf-account-opening/imf-account-opening-config-page').then((m) => m.ImfAccountOpeningConfigPage),
      },
      {
        path: 'imf-account-opening/:id',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN'],
        },
        loadComponent: () => import('./features/imf-account-opening/imf-opening-request-detail-page').then((m) => m.ImfOpeningRequestDetailPage),
      },
      {
        path: 'imf-account-opening',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN'],
        },
        loadComponent: () => import('./features/imf-account-opening/imf-account-opening-page').then((m) => m.ImfAccountOpeningPage),
      },
      {
        path: 'loan-applications/:id',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN'],
        },
        loadComponent: () => import('./features/admin-financing-applications/admin-financing-application-details-page').then((m) => m.AdminFinancingApplicationDetailsPage),
      },
      {
        path: 'admin-financing-applications',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/admin-financing-applications/admin-financing-applications-page').then((m) => m.AdminFinancingApplicationsPage),
      },
      {
        path: 'admin-financing-applications/:id',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN'],
        },
        loadComponent: () => import('./features/admin-financing-applications/admin-financing-application-details-page').then((m) => m.AdminFinancingApplicationDetailsPage),
      },
      {
        path: 'admin-wallet-monitoring',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/admin-wallet-monitoring/admin-wallet-monitoring-page').then((m) => m.AdminWalletMonitoringPage),
      },
      {
        path: 'admin/wallet-audit',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/wallet-audit/wallet-audit-page').then((m) => m.WalletAuditPage),
      },
      {
        path: 'commerce/analytics',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/backoffice-analytics/backoffice-analytics-page').then((m) => m.BackofficeAnalyticsPage),
      },
      {
        path: 'commerce/merchants',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/backoffice-merchants/backoffice-merchants-page').then((m) => m.BackofficeMerchantsPage),
      },
      {
        path: 'commerce/products',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/backoffice-products/backoffice-products-page').then((m) => m.BackofficeProductsPage),
      },
      {
        path: 'commerce/orders',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/backoffice-orders/backoffice-orders-page').then((m) => m.BackofficeOrdersPage),
      },
      {
        path: 'commerce/events',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/backoffice-events/backoffice-events-page').then((m) => m.BackofficeEventsPage),
      },
      {
        path: 'admin-ledger',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/admin-ledger/admin-ledger-page').then((m) => m.AdminLedgerPage),
      },
      {
        path: 'admin-membership-repair',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/admin-membership-repair/admin-membership-repair-page').then((m) => m.AdminMembershipRepairPage),
      },
      {
        path: 'prayer/requests',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/prayer-requests/prayer-requests-page').then((m) => m.PrayerRequestsPage),
      },
      {
        path: 'moderation/reports',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/moderation-reports/moderation-reports-page').then((m) => m.ModerationReportsPage),
      },
      {
        // Accompagnement Gen1 (UX-3, lot B) : file de l'équipe, hors des écrans financiers.
        path: 'gen1-help',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/gen1-help/gen1-help-page').then((m) => m.Gen1HelpPage),
      },
      {
        path: 'prayer/loop',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/prayer-loop/prayer-loop-page').then((m) => m.PrayerLoopPage),
      },
      {
        path: 'support/ops-alerting',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/ops-alerting/ops-alerting-page').then((m) => m.OpsAlertingPage),
      },
      {
        path: 'mlm/network-maintenance',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/mlm-network-maintenance/mlm-network-maintenance-page').then((m) => m.MlmNetworkMaintenancePage),
      },
      {
        path: 'financial-control-tower/operations/:operationId',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/financial-control-tower/financial-control-tower-operation-detail-page').then((m) => m.FinancialControlTowerOperationDetailPage),
      },
      {
        path: 'financial-control-tower',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/financial-control-tower/financial-control-tower-page').then((m) => m.FinancialControlTowerPage),
      },
      {
        path: 'psp-ops-actions',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/psp-ops-actions/psp-ops-actions-page').then((m) => m.PspOpsActionsPage),
      },
      {
        path: 'financial-ops',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/financial-ops/financial-ops-page').then((m) => m.FinancialOpsPage),
      },
      {
        path: 'partner-users',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/partner-users/partner-users-page').then((m) => m.PartnerUsersPage),
      },
      {
        path: 'partner-reporting',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_PARTNER_ADMIN', 'ROLE_PARTNER_ANALYST'],
        },
        loadComponent: () => import('./features/partner-reporting-dashboard/partner-reporting-dashboard').then((m) => m.PartnerReportingDashboard),
      },
      {
        path: 'circles',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/circles/circles').then((m) => m.Circles),
      },
      {
        path: 'loans',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/loans/loans').then((m) => m.Loans),
      },
      {
        path: 'capital',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_IMF_ADMIN'],
        },
        loadComponent: () => import('./features/capital/capital').then((m) => m.Capital),
      },
      {
        path: 'treasury',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN'],
        },
        loadComponent: () => import('./features/treasury/treasury').then((m) => m.Treasury),
      },
      {
        path: 'agents',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/agents/agents').then((m) => m.Agents),
      },
      {
        path: 'notifications',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/notifications/notifications').then((m) => m.Notifications),
      },
      {
        path: 'communications',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/communication-center/communication-center-page').then((m) => m.CommunicationCenterPage),
      },
      {
        path: 'countries',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/countries/countries').then((m) => m.Countries),
      },
      {
        path: 'country-leadership',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_TREASURER', 'ROLE_AUDITOR'],
        },
        loadComponent: () => import('./features/country-leadership/country-leadership-dashboard-page').then((m) => m.CountryLeadershipDashboardPage),
      },
      {
        path: 'countries/:countryCode',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/countries/country-details-page').then((m) => m.CountryDetailsPage),
      },
      {
        path: 'countries/:countryCode/setup',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
          configPageMode: 'country-setup',
        },
        loadComponent: () => import('./features/country-config/country-config-page').then((m) => m.CountryConfigPage),
      },
      {
        path: 'media',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/media/media').then((m) => m.Media),
      },
      {
        path: 'platform-configuration',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN'],
          configPageMode: 'platform-config',
        },
        loadComponent: () => import('./features/country-config/country-config-page').then((m) => m.CountryConfigPage),
      },
      {
        path: 'mobile-app-version',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/mobile-app-version/mobile-app-version-page').then((m) => m.MobileAppVersionPage),
      },
      {
        path: 'country-config',
        pathMatch: 'full',
        redirectTo: 'countries',
      },
      {
        path: 'country-config/accounts',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/country-config/country-chart-accounts-page').then((m) => m.CountryChartAccountsPage),
      },
      {
        path: 'configuration',
        pathMatch: 'full',
        redirectTo: 'countries',
      },
      {
        path: 'community',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/community/community-list-page').then((m) => m.CommunityListPage),
      },
      {
        path: 'community/create',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_OPERATIONS'],
        },
        loadComponent: () => import('./features/community/community-create-page').then((m) => m.CommunityCreatePage),
      },
      {
        path: 'audit',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN'],
        },
        loadComponent: () => import('./features/audit/audit').then((m) => m.Audit),
      },
      {
        path: 'admin-accounts',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN'],
        },
        loadComponent: () => import('./features/admin-accounts/admin-accounts-page').then((m) => m.AdminAccountsPage),
      },
      {
        path: 'admin/engagement/tasks',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN'],
        },
        loadComponent: () => import('./features/engagement-tasks/pages/tasks-list/tasks-list-page').then((m) => m.TasksListPage),
      },
      {
        path: 'admin/bug-tracker',
        canActivate: [roleGuard],
        data: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_SUPPORT'],
        },
        loadComponent: () => import('./features/bug-tracker/pages/bug-tracker-page').then((m) => m.BugTrackerPage),
      },
      ...devToolsRoutes,
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
